var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"message",class:_vm.props.data.modifier},[_vm._v(_vm._s(_vm.props.data.message))])}
var staticRenderFns = []

export { render, staticRenderFns }